import { QUOTES,QUOTES_ESTIMATE } from './endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class QuotesService extends BaseService {

    constructor(http: HttpClient) {
        super(http);
    }

    getItems(quotesParams: any): Observable<any> {        
        const url = QUOTES + '?' + this.makeQueryString(quotesParams);
        return this.getRequest(url, null);
    }

    getQuotesById(quotesId: any): Observable<any> {
        const url = QUOTES + '/' + quotesId;       
        return this.getRequest(url, null);
    }

    update(quotesId: number, updateParams: any): Observable<any> {
        const url = quotesId?QUOTES + '/' + quotesId:QUOTES;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.putRequest(url, updateParams, options);
    }
    quotes(data:any){
        const url = QUOTES;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.postRequest(url,data,options);
    }
    estimate(data:any){
        const url = QUOTES_ESTIMATE;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.postRequest(url,data,options);
    }

    save(data){
        const url = QUOTES;
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return  this.postRequest(url,data,options);
    }
}
